
import React from "react";

const style = {
    background:'rgba(0,0,0,0.7)',
    position:'fixed',
    top:0,
    left:0,
    right:0,
    bottom:0,
    zIndex:1000,
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    zIndex:9999
}

function spinner(){
    return (
        < div style={style}  >
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    )
};


export default spinner;